<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">班級幹部資料</span>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                    <div is="option" value="u">上</div>
                    <div is="option" value="d">下</div>
                </form-select>
            </div>
            <!--<div class="col-12">
                <form-input v-model="vm.ClassID" id="ClassID" label="班級" type="text" classlist required></form-input>
            </div>-->
            <div class="col-12">
                <form-select v-model="vm.Job" id="Job" label="職務" required>
                    <slot name="job"></slot>
                </form-select>
            </div>
            <div class="col-12">
                <label>學號</label>
                <input v-model="vm.StudentNo" id="StudentNo" type="text" class="form-control" @change="studentNoChange" required />
            </div>
            <div class="col-12">
                <form-input v-model="vm.Tel" id="Tel" label="電話" type="text" required></form-input>
            </div>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'classcadreDetail',
        api: '/api/classcadre/',
        methods: {
            studentNoChange: function () {
                this.$parameter.sinfo(this.vm.StudentNo)
                    .then((res) => {
                        this.vm.Tel = res.data.phone;
                    })
            },
        }
    });
</script>

<style>
</style>